import { SHOW_BILLING_ADDRESS_FORM } from './BillingAddressPageConstants';
import { PAGE_NAME } from '../../config/pageNames';
import {FORM_ID, NETWORK} from '../../../framework/App/AppConstants';
import { setServerData } from '../../../framework/store/ServerData/ServerDataActions';
import { trackTransition, recordImpression } from '../../../framework/store/FPTI/FPTIActions';
import { push } from 'connected-react-router';
import _ from 'lodash';
import axios from 'axios';
import { scrollToTop } from '../../../framework/App/SkeletonPage/SkeletonPageActions';
import { spinnerClose } from '../../../framework/components/FullPageSpinner/FullPageSpinnerActions';
import setUrl from '../../../framework/App/SetUrl';
import { APPLICATION_STATUS } from '../../USConstants';
import { SubmissionError, change, touch } from 'redux-form';
import { handleServerSideErrors } from '../../utils/USUtils';

export const handleRedirect = response => {
    if (response && _.get(response, 'data.redirect')) {
        setUrl(window, response.data.redirect);
        return true;
    }
    return false;
};

export const showBillingAddressForm = (val) => {
    return {
        type: SHOW_BILLING_ADDRESS_FORM,
        payload: val
    };
};

export const submitBillingInfo = (url, data, nextPage) => (dispatch, getState) => {
    const { serverData = {} } = getState();
    const { _csrf = '' } = serverData;
    return axios
        .request({
            method: 'post',
            url,
            headers: {
                ...NETWORK.REQUEST.XHR.HEADER,
                'X-CSRF-Token': _csrf
            },
            data
        })
        .then(async(response) => {
            const appStatus = _.get(response, 'data.applicationStatus');
            window.appStatus = appStatus; // used by recordImpression
            // handle server-side errors
            await handleServerSideErrors(dispatch, getState, response);
            if (_.get(response, 'data.validationErrors')) { //When ANS detects a non-military delivery address
                const pageName = _.get(response, 'data.pageName');
                const validationErrors = _.get(response, 'data.validationErrors');
                const showDeliveryAddressValidationError = _.get(response, 'data.showDeliveryAddressValidationError');
                capeLog && capeLog(`response:Validation error on page: ${pageName} showDeliveryAddressValidationError: ${showDeliveryAddressValidationError}`);
                dispatch(setServerData({
                    validationErrorModel: validationErrors,
                    decisionModel: response.data,
                    showValidationSoftDecline: false,
                    showDeliveryAddressValidationError,
                    userLoggedIn: _.get(response, 'data.userLoggedIn')
                }));
                for (const validationError of validationErrors) {
                    dispatch(change(FORM_ID, validationError.field, ''));
                    dispatch(touch(FORM_ID, validationError.field));
                }
                dispatch(push(pageName));
                dispatch(spinnerClose());
                dispatch(trackTransition('pp_credit_billinginfopage', 'prepare_pp_credit_billinginfopage', { ppc_status: _.get(response, 'data.applicationStatus', '') }));
                recordImpression('billinginfopage', appStatus);
            } else if (_.has(response, 'data.normalized')) { //Address normalization was successful
                dispatch(spinnerClose());
                dispatch(setServerData({
                    appStatus,
                    decisionModel: {},
                    showValidationSoftDecline: false,
                    userLoggedIn: _.get(response, 'data.userLoggedIn')
                }));

                // when normalized is true, it means the address was good.
                // when normalized is false, it means there was an unknown error.
                // in both cases, we are letting the user continue to the next page.
                dispatch(push(nextPage));
            } else if (_.get(response, 'data.showValidationSoftDecline')) { //ANS soft decline
                dispatch(scrollToTop());
                dispatch(spinnerClose());
                dispatch(setServerData({
                    appStatus,
                    decisionModel: response.data,
                    showValidationSoftDecline: _.get(response, 'data.showValidationSoftDecline'),
                    userLoggedIn: _.get(response, 'data.userLoggedIn')
                }));
                dispatch(trackTransition('pp_credit_billinginfopage', 'prepare_pp_credit_billinginfopage', { ppc_status: _.get(response, 'data.applicationStatus', '') }));
                recordImpression('billinginfopage', appStatus);
            } else if (appStatus === APPLICATION_STATUS.STOP_SOFT_DECLINED) { //soft decline or ANS delivery service validation error exceeded the max threshold
                // show final decline page after with soft decline message after 3 times soft decline or <n> times delivery service validation error where n is the
                // maximum threshold set for the decline type.
                dispatch(scrollToTop());
                dispatch(spinnerClose());
                dispatch(setServerData({
                    appStatus,
                    decisionModel: response.data,
                    showValidationSoftDecline: _.get(response, 'data.showValidationSoftDecline'),
                    userLoggedIn: _.get(response, 'data.userLoggedIn')
                }));
                dispatch(push(PAGE_NAME.DECISION_PAGE));
            } else {
                // some error
                dispatch(spinnerClose());
                dispatch(push(PAGE_NAME.ERROR_PAGE));
            }
        })
        .catch(error => {
            // show server-side errors on form
            if (error instanceof SubmissionError) {
                return Promise.reject(error);
            }
            capeLog && capeLog('response:error, US BillingAddressPageActions,' + (error && error.message));

            if (handleRedirect(error && error.response)) {
                return;
            }

            if (_.get(error, 'response.data.err', false)) {
                dispatch(spinnerClose());
                dispatch(setServerData({ errorModel: _.get(error, 'response.data', {}) }));
                dispatch(push(PAGE_NAME.ERROR_PAGE));
            } else {
                // should never be here
                capeLog && capeLog('response:error: unexpected error response for BillingAddressPage submit');
                setUrl(window, PAGE_NAME.ERROR_PAGE);
            }
        });
};
